import React from 'react';

export default function ContactUs() {
  return (
    <div class="footer wow fadeIn" data-wow-delay="0.3s">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-3">
            <div class="footer-contact">
              <h2>Office Contact</h2>
              <p>
                <i class="fa fa-map-marker-alt"></i>2 nd Floor Crescent Building
                Pantheerankavu, Kozhikode, Kerala
              </p>
              <p>
                <i class="fa fa-phone-alt"></i>+918848810561
              </p>
              <p>
                <i class="fa fa-envelope"></i>projects@calinfra.in
              </p>
              <div class="footer-social">
                <a href="">
                  <i class="fab fa-twitter"></i>
                </a>
                <a href="">
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a href="">
                  <i class="fab fa-youtube"></i>
                </a>
                <a href="">
                  <i class="fab fa-instagram"></i>
                </a>
                <a href="">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="footer-link">
              <h2>Services Areas</h2>
              <a href="">Building Construction</a>
              <a href="">House Renovation</a>
              <a href="">Architecture Design</a>
              <a href="">Interior Design</a>
              <a href="">Painting</a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="footer-link">
              <h2>Useful Pages</h2>
              <a href="">About Us</a>
              <a href="">Contact Us</a>
              <a href="">Our Team</a>
              <a href="">Projects</a>
              <a href="">Testimonial</a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="newsletter">
              <h2>Newsletter</h2>
              <p>
                CALINFRA is an Indian incorporated company and locally owned.
                The company offers Engineering and construction project
                management.
              </p>
              <div class="form">
                <input class="form-control" placeholder="Email here" />
                <button class="btn">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container footer-menu">
        <div class="f-menu">
          <a href="">Terms of use</a>
          <a href="">Privacy policy</a>
          <a href="">Cookies</a>
          <a href="">Help</a>
          <a href="">FQAs</a>
        </div>
      </div>
      <div class="container copyright">
        <div class="row">
          <div class="col-md-6">
            <p>
              &copy; <a>Calinfra</a>, All Right Reserved.
            </p>
          </div>
          <div class="col-md-6">
            <p>
              Designed By{' '}
              <a href="https://www.luzidcraft.com/" target="_blank">
                Luzidcraft
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
